import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCausesCondictionsChartsDataContext } from './hooks/useCausesCondictionsChartsDataContext';

export const CirurgyConfirmation = () => {
    const { chartData } = useCausesCondictionsChartsDataContext();

    return (
        <SimpleBars
            title={'Confirmação de Cirurgia'}
            horizontal={true}
            subtitles={chartData?.cirurgyConfirmation?.map(
                (item) => item.description
            )}
            values={chartData?.cirurgyConfirmation?.map(
                (item) => item.total || 0
            )}
            className="aligned-container"
        />
    );
};
